export default __webpack_public_path__ + "static/media/tableEditWhiteIcon.8bfac9f6.svg";